<template>
  <article class="layout-landing">
    <header-nav class="pc-only" />
    <div
      ref="container"
      :style="{
        backgroundImage: `url(${transformImage(
          getFeUrl(
            `/youyan-platform/png/${
              getEnv('area') === 'CN' ? 'white' : 'black2'
            }.png`
          )
        )})`,
      }"
      class="bg-white w-screen h-screen overflow-hidden"
    >
      <slot />
    </div>
  </article>
  <sound-btn
    class="pc-only fixed bottom-[36px] right-[40px] w-[40px] h-[40px] rounded-[40px] z-[200] cursor-pointer flex-center muted-btn"
    :muted="muted"
    @click="toggleMuted"
  />
  <OnlineService class="fixed bottom-[86px] right-[36px]" />
</template>

<script lang="ts" setup>
import Scrollbar from 'smooth-scrollbar'
import HeaderNav from '@/features/landing/header-nav/index.vue'
import SoundBtn from '@/features/landing/sound-btn/index.vue'
import OnlineService from '@/features/floatComps/onlineService.vue'

const container = ref<HTMLElement>()
const muted = ref(true)
provide('isMuted', muted)
const toggleMuted = () => (muted.value = !muted.value)

onMounted(() => {
  if (container.value) {
    const scrollbar = Scrollbar.init(container.value, { damping: 0.05 })
    scrollbar.addListener((status) => {
      document.body.dispatchEvent(
        new CustomEvent('scroll', {
          detail: {
            scrollY: status.offset.y,
          },
        })
      )
    })
  }
})

useHead({
  meta: [
    {
      property: 'og:image',
      content: getFeUrl('/youyan-platform/png/homepage.png'),
    },
  ],
})
</script>
